<!-- 
 就诊管理
 该页面有两种加载模式：
 1、获取全部数据
 2、根据老人id，获取指定老人的数据
 该页面在个人信息模块作为子组件的时候会使用第二种模式
 -->
<template>
  <div>
    <el-form v-if="!userId" ref="queryForm" :inline="true" :model="queryForm" size="small">
      <el-form-item label="姓名" prop="member_keyword">
        <el-input v-model="queryForm.member_keyword"></el-input>
      </el-form-item>
      <el-form-item label="就诊时间">
        <el-date-picker v-model="dateRange" @change="handleDateRangeChange" type="daterange" value-format="yyyy-MM-dd"
          start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="记录人" prop="user_keyword">
        <el-input v-model="queryForm.user_keyword"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleSearch" type="primary">查询</el-button>
        <el-button @click="handleReset" type="infor">重置</el-button>
        <el-button @click="handleAdd" type="primary" size="small">新增</el-button>
      </el-form-item>
    </el-form>
    <!-- 界面第二种模式时使用 -->
    <div v-else style="margin-bottom: 10px;">
      <el-button @click="handleAdd" type="primary" size="small">新增</el-button>
      <el-button @click="getSeeDoctorData" size="small">刷新</el-button>
    </div>

    <el-table :data="tableData" v-loading="tableLoading" border stripe
      :header-cell-style="{background:'#E4E7ED',color: '#606266'}" size="small" max-height="500px" style="width: 100%;">
      <el-table-column label="#" type="index" width="60"></el-table-column>
      <el-table-column label="姓名" prop="member_info.realname"></el-table-column>
      <el-table-column label="就诊时间" prop="time"></el-table-column>
      <el-table-column label="就诊类型" v-slot="{ row }">{{ row.type == 1 ? '日常陪诊' : '急诊' }}</el-table-column>
      <el-table-column label="陪诊人员" prop="member_escort.name"></el-table-column>
      <el-table-column label="医院" prop="hospital"></el-table-column>
      <el-table-column label="科室" prop="department"></el-table-column>
      <el-table-column label="医生" prop="doctor"></el-table-column>
      <el-table-column label="操作" fixed="right">
        <template v-slot="{ row }">
          <el-link @click="handleView(row)" type="primary" class="margin-r-10">查看</el-link>
          <el-link @click="handleEdit(row)" type="primary" class="margin-r-10">编辑</el-link>
          <el-popconfirm @confirm="handleDel(row.id)" title="确定删除吗？">
            <el-link slot="reference" type="danger">删除</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div class="margin-t-10 flex">
      <el-pagination background layout="prev, pager, next, total, jumper" :total="total"
        :current-page.sync="queryForm.page" :page-size="queryForm.page_size" @current-change="getSeeDoctorData">
      </el-pagination>
      <el-button size="small">确定</el-button>
    </div>

    <!-- 新增、编辑的弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="showDialog" :close-on-click-modal="false" @close="closeDialog"
      width="700px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row>
          <el-col v-if="!userId" :span="12">
            <el-form-item label="选择老干部" prop="member_id">
              <el-select v-model="form.member_id" clearable filterable remote :remote-method="getRecordData"
                :loading="recordLoading" placeholder="输入姓名进行查找" class="el-input_inner--rewrite">
                <el-option v-for="record in recordData" :key="record.id" :label="record.realname" :value="record.id">
                  <div class="flex justify-content-s-b">
                    <span>{{ record.realname }}</span><span>{{ record.birthday }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="就诊时间" prop="time">
              <el-date-picker v-model="form.time" type="date" value-format="yyyy-MM-dd"
                placeholder="选择时间"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="就诊类型" prop="type">
              <el-select v-model="form.type" placeholder="请选择" class="el-input_inner--rewrite">
                <el-option label="日常陪诊" :value="1"></el-option>
                <el-option label="急诊" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="陪诊人员" prop="escort">
              <el-select v-model="form.escort" clearable filterable placeholder="请选择" class="el-input_inner--rewrite">
                <el-option v-for="item in escorts" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="医院" prop="hospital">
              <el-input v-model="form.hospital"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="科室" prop="department">
              <el-input v-model="form.department"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="医生" prop="doctor">
              <el-input v-model="form.doctor"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="主要病情" prop="record_content">
              <el-input v-model="form.record_content" type="textarea"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="处置情况" prop="doctor_advised">
              <el-input v-model="form.doctor_advised" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button :loading="formSubmitting" @click="handleSubmit" type="primary">提交</el-button>
      </span>
    </el-dialog>

    <!-- 查看的弹窗 -->
    <el-dialog title="查看就诊信息" :visible.sync="showPreviewDialog" width="550px">
      <el-descriptions v-if="curRowData !== null" :column="1" border :labelStyle="{width: '100px'}">
        <el-descriptions-item label="姓名">{{ curRowData.member_info.realname }}</el-descriptions-item>
        <el-descriptions-item label="就诊时间">{{ curRowData.time }}</el-descriptions-item>
        <el-descriptions-item label="就诊类型">{{ curRowData.type == 1 ? '日常陪诊' : '急诊' }}</el-descriptions-item>
        <el-descriptions-item label="陪诊人员">{{ curRowData.member_escort.name }}</el-descriptions-item>
        <el-descriptions-item label="医院">{{ curRowData.hospital }}</el-descriptions-item>
        <el-descriptions-item label="科室">{{ curRowData.department }}</el-descriptions-item>
        <el-descriptions-item label="医生">{{ curRowData.doctor }}</el-descriptions-item>
        <el-descriptions-item label="主要病情">{{ curRowData.record_content }}</el-descriptions-item>
        <el-descriptions-item label="处置情况">{{ curRowData.doctor_advised }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button @click="showPreviewDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getUserRecordDataAPI
  } from '@/api/user-record/record.js'
  import {
    saveSeeDoctorAPI,
    getSeeDoctorDataAPI,
    delSeeDoctorDataAPI,
  } from '@/api/see-doctor.js'
  import {
    getEscortsAPI
  } from '@/api/escort.js'

  export default {
    name: 'SeeDoctor',
    props: {
      userId: Number,
      tabName: String,
    },
    data() {
      return {
        // 陪诊人员数据
        escorts: [],

        // 头部搜索相关
        dateRange: [],
        queryForm: {
          page: 1,
          page_size: 10,
          member_keyword: '',
          user_keyword: '',
          start: '',
          end: '',
          member_id: ''
        },
        // 表格
        tableData: [],
        total: 0,
        pageSize: 0,
        tableLoading: false,

        // 查看相关
        curRowData: null,
        showPreviewDialog: false,

        // 档案数据
        recordData: [],
        recordLoading: false,

        // 表单相关
        showDialog: false,
        dialogTitle: '',
        formSubmitting: false,
        form: {
          member_id: '',
          type: '',
          hospital: '',
          department: '',
          doctor: '',
          record_content: '',
          doctor_advised: '',
          escort: '',
          time: '',
        },
        rules: {
          member_id: [{
            required: true,
            message: '姓名不能为空',
            trigger: 'change'
          }],
          time: [{
            required: true,
            message: '就诊时间不能为空',
            trigger: 'change'
          }],
          type: [{
            required: true,
            message: '就诊类型不能为空',
            trigger: 'change'
          }],
          hospital: [{
            required: true,
            message: '医院不能为空',
            trigger: 'blur'
          }],
          department: [{
            required: true,
            message: '科室不能为空',
            trigger: 'blur'
          }],
          doctor: [{
            required: true,
            message: '医生不能为空',
            trigger: 'blur'
          }],
          record_content: [{
            required: true,
            message: '主要病情不能为空',
            trigger: 'blur'
          }],
          doctor_advised: [{
            required: true,
            message: '处置情况不能为空',
            trigger: 'blur'
          }],
          escort: [{
            required: true,
            message: '陪诊人员不能为空',
            trigger: 'change'
          }],
        }
      }
    },
    watch: {
      // 如果父级 userId 改变了，并且父级当前的 tabname 等于本组件的名字，就获取最新下数据
      userId: {
        immediate: true,
        handler() {
          if (this.tabName === 'SeeDoctor') {
            this.queryForm.member_id = this.userId
            this.form.member_id = this.userId

            this.getSeeDoctorData()
          }
        }
      },
      // 如果父级 tabName 改变了，并且父级当前的 tabname 等于本组件的名字，就获取最新下数据
      tabName(newVal) {
        if (newVal === 'SeeDoctor') {
          this.queryForm.member_id = this.userId
          this.form.member_id = this.userId
          this.getSeeDoctorData()
        }
      }
    },
    created() {
      if (!this.userId) {
        this.getSeeDoctorData()
        this.getRecordData()
      }
      getEscortsAPI().then(res => this.escorts = res)
    },
    methods: {
      // 新增按钮
      handleAdd() {
        this.dialogTitle = '新增'
        this.showDialog = true
      },
      // 重置按钮
      handleReset() {
        this.dateRange = []
        this.$refs.queryForm.resetFields()
      },
      // 搜索按钮
      handleSearch() {
        this.queryForm.page = 1
        this.getSeeDoctorData()
      },
      // 查看按钮
      handleView(row) {
        this.showPreviewDialog = true
        this.curRowData = row
      },
      // 删除按钮
      handleDel(id) {
        delSeeDoctorDataAPI({
          id,
        }).then(res => {
          if (res.code === 0) {
            this.$message.success(res.msg)
            this.getSeeDoctorData()
          }
        })
      },
      // 编辑按钮
      handleEdit(row) {
        this.showDialog = true
        this.dialogTitle = '编辑'
        this.curRowData = JSON.parse(JSON.stringify(row))
        // 回显老人
        this.recordData = [this.curRowData.member_info]
        // 设置 form
        for (let key in this.form) {
          this.form[key] = this.curRowData[key]
        }
      },
      handleDateRangeChange(e) {
        this.queryForm.start = e[0]
        this.queryForm.end = e[1]
      },
      // 关闭弹窗
      closeDialog() {
        this.showDialog = false
        this.$refs.form.resetFields()
      },
      // 提交按钮
      handleSubmit() {

        this.$refs.form.validate(isValid => {
          if (!isValid) return

          this.formSubmitting = true
          const copyForm = JSON.parse(JSON.stringify(this.form))
          copyForm.user_id = sessionStorage.getItem('systemUserId')

          if (this.dialogTitle === '编辑') copyForm.id = this.curRowData.id
          // 提交
          saveSeeDoctorAPI(copyForm).then(res => {
            this.$message.success(res.msg)
            this.closeDialog()
            this.getSeeDoctorData()
          }).finally(() => this.formSubmitting = false)
        })
      },
      // 获取档案数据
      getRecordData(keyword) {
        this.recordLoading = true

        setTimeout(() => {
          getUserRecordDataAPI({
            page: 1,
            keyword,
          }).then(res => {
            this.recordData = res.data
            this.recordLoading = false
          })
        }, 300)
      },
      // 获取就诊数据
      getSeeDoctorData() {
        this.tableLoading = true

        getSeeDoctorDataAPI(this.queryForm).then(res => {
          this.tableData = res.data
          this.total = res.total
          this.pageSize = res.per_page
          this.tableLoading = false
        })
      },
    }
  }
</script>

<style>
</style>